import { Row, RowData } from '@tanstack/react-table';
import dayjs from 'dayjs';

import { DateRangeValue } from './CalendarPicker/CalendarPicker';

export const openColumnFilter = (filterId: string) => {
  const th = document.querySelector<HTMLElement>(`th[data-column-id="${filterId}"]`);
  if (!th) return;
  th.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  th.querySelector<HTMLElement>('button')?.click();
};

export const textFilterFn = <TData extends RowData>(row: Row<TData>, id: string, value: string[]) => {
  const filterStr = String(value?.[0] ?? '').toLowerCase();
  if (!filterStr) return true;
  return String(row.getValue(id) ?? '')
    .toLowerCase()
    .includes(filterStr);
};

export const relativeTimeFilterFn =
  (fallback: string) =>
  <TData extends RowData>(row: Row<TData>, id: string, value: string[]) => {
    const filterStr = String(value?.[0] ?? '').toLowerCase();
    if (!filterStr) return true;
    const raw = row.getValue(id);
    const displayed = raw ? dayjs(raw as string).fromNow() : fallback;
    return displayed.toLowerCase().includes(filterStr);
  };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const dateRangeFilterFn = <TData extends RowData>(row: Row<TData>, id: string, value: any) => {
  const { after, before } = (value ?? {}) as DateRangeValue;
  if (!after && !before) return true;
  const raw = row.getValue(id);
  if (!raw) return false;
  const date = dayjs(raw as string);
  if (after && date.isBefore(dayjs(after))) return false;
  if (before && date.isAfter(dayjs(before).endOf('day'))) return false;
  return true;
};
